import { Fragment, ReactNode } from "react";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";

interface DropdownMenuProps {
	id?: string;
	buttonLabel: ReactNode;
	buttonClassName?: string;
	anchor?: "bottom start" | "bottom end" | "top start" | "top end";
	menuClassName?: string;
	children: ReactNode;
}

export default function DropdownMenu({
	id,
	buttonLabel,
	buttonClassName = "btn btn-neutral",
	anchor = "bottom start",
	menuClassName = "absolute z-10 pb-1 rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden hover:cursor-pointer",
	children,
}: DropdownMenuProps) {
	return (
		<Menu as="div" className="relative inline-block text-left">
			<MenuButton id={id} className={buttonClassName}>
				{buttonLabel}
			</MenuButton>
			<Transition
				as={Fragment}
				leave="transition ease-in duration-75"
				leaveFrom="transform opacity-100 scale-100"
				leaveTo="transform opacity-0 scale-95">
				<MenuItems anchor={anchor} className={menuClassName}>
					{children}
				</MenuItems>
			</Transition>
		</Menu>
	);
}

interface MenuActionItemProps {
	label: string;
	icon?: ReactNode;
	onClick: () => void;
}

export function MenuActionItem({ label, icon, onClick }: MenuActionItemProps) {
	return (
		<MenuItem>
			<button
				onClick={onClick}
				className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100">
				<div className="flex items-center">
					{icon && <span className="mr-2 flex items-center">{icon}</span>}
					{label}
				</div>
			</button>
		</MenuItem>
	);
}
